
import { defineComponent } from "vue";
import Vue3Slider from "@/vue3-slider.vue";

export default defineComponent({
  name: "ServeDev",
  components: {
    Vue3Slider,
  },
  data() {
    return {
      sliderVal: 30,
      expand: false,
      showInputs: false,
      height: 10,
      width: 200,
      min: 0,
      max: 100,
      step: 1,
      limit: undefined,
      handleScale: 1.35,
      tooltip: true,
      tooltipText: "%v",
      orientation: "horizontal",
      colorShift: false,
      sticky: false,
      repeat: false,
      flip: false,
      disabled: false,
      circleOffset: 0,
      circleGap: 0,
      alwaysShowTooltip: false,
      alwaysShowHandle: false,
      flipTooltip: false,
      customSliderStepsText: "",
      tooltipStylesText: "{}",
      handleColor: "",
    };
  },
  computed: {
    customSliderSteps(): number[] | undefined {
      if (this.customSliderStepsText) {
        return this.customSliderStepsText.split(",").map((step: string) => Number(step.trim()));
      }

      return undefined;
    },
    tooltipStyles(): Record<string, string> {
      if (this.tooltipStylesText) {
        try {
          return JSON.parse(this.tooltipStylesText);
        } catch (error) {
          return {};
        }
      }

      return {};
    },
  },
  methods: {
    openControls() {
      if (!this.expand) {
        this.showInputs = true;
      } else {
        setTimeout(() => (this.showInputs = false), 300);
      }

      setTimeout(() => (this.expand = !this.expand), 10);
    },
  },
});
